import ui from '@nuxt/ui/vue-plugin'
import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import './assets/main.css'
import { CANVAS_DATA } from './design/libs/canvasData'
import { consoleCanvasData } from './design/libs/liveData'
import i18n from './libs/i18n'
import { createSentry } from './libs/sentry'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(router)
app.use(ui)
// The console's canvases ask its API for what their caller did not pass (the player does not).
app.provide(CANVAS_DATA, consoleCanvasData)

createSentry(app)
app.mount('#app')
